import styled from 'styled-components';

const StyledAccountDetailsGrid = styled.div`
	--grid-template-columns: 1fr var(--px-215) repeat(5, var(--px-50)) var(--px-200);
	flex: 1;
	display: grid;
	grid-template-columns: var(--grid-template-columns);
	grid-template-rows: auto;
	gap: var(--spacing-x-large);
	padding-right: calc(var(--spacing-xx-large) + var(--border-width-small) - var(--spacing-large));
	align-items: center;

	.create-comment-container {
		.motif-button {
			justify-self: end;
		}
	}
`;

export const StyledAccountDetailsGridHeader = styled(StyledAccountDetailsGrid)`
	padding-right: calc(var(--spacing-xx-large) + var(--border-width-small));
	flex: 0;
`;

export const StyledAccountDetailsGridContent = styled(StyledAccountDetailsGrid)`
	padding-right: unset;
	flex: 0;
	&.has-psp {
		align-items: start;
	}
`;

export default StyledAccountDetailsGrid;
